import moment from 'moment';
import {  DEFAULT_DATE_FORMAT_WITH_COMMA } from '../constants/dateFormats';

export default function formatDate(date, format = DEFAULT_DATE_FORMAT_WITH_COMMA){
    const momentObj = moment(date);

    return momentObj.isValid() ? momentObj.format(format) : "-";
}